<template>
  <div v-if="isMobileLandscape" class="footer-wrapper">
    <Logo />
    <div class="menu-btn">
      <div class="balance relative">
        {{ currencySymbol }} <animated-amount :value="balance" :formatValue="formatAmount" :duration="500" />
        <Transition name="fade">
          <div v-if="futureDiff" class="furture-diff">+ {{ userFutureDiff }}</div>
        </Transition>
      </div>
      <div class="burger-menu">
        <BurgerMenu v-if="!isPopupOpen" />
      </div>
    </div>
  </div>
</template>
<script>
import BurgerMenu from '@/components/burger-menu.vue';
import { formatAmount } from '@/utils/helpers';
import { mapGetters } from 'vuex';
import { isMobile } from 'mobile-device-detect';
import Logo from '@/components/logo.vue';
import AnimatedAmount from '@/components/animated-amount.vue';

export default {
  components: {
    AnimatedAmount,
    BurgerMenu,
    Logo,
  },
  data: () => {
    return {
      formatAmount,
    };
  },
  computed: {
    ...mapGetters({
      balance: 'general/balance',
      futureDiff: 'general/futureDiff',
      isPopupOpen: 'menu/isPopupOpen',
      member: 'general/member',
    }),
    userFutureDiff() {
      return formatAmount(this.futureDiff, 2);
    },
    isMobileLandscape() {
      return isMobile && this.$screen.width >= this.$screen.height;
    },
    currencySymbol() {
      return this.member.currencySymbol;
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-wrapper {
  height: 48px;
  position: fixed;
  width: 50%;
  z-index: 10;
  bottom: 0;
  padding: 8px 16px;
  box-sizing: border-box;
  background-color: #08172e;
  display: flex;
  justify-content: space-between;
  border-radius: 14px 14px 0px 0px;

  .logo {
    height: 28px;
  }

  .menu-btn {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 100%;

    .balance {
      text-transform: uppercase;
      font-size: 13px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      margin-right: 12px;
      color: #fcc751;
      font-feature-settings: 'tnum' on, 'lnum' on;

      img {
        height: 12px;
        width: 12px;
        margin-right: 5px;
      }

      .furture-diff {
        position: absolute;
        bottom: 100%;
        right: 0;
        font-size: 10px;
        font-weight: 600;
        color: #ffefcc;
      }
    }

    .burger-menu {
      display: block;
      height: 32px;
      width: 32px;
    }
  }
}
</style>
